

































import {Component, Prop, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import {Call, Sync} from 'vuex-pathify';
import CompletePurchaseDialog from '@/components/Views/Cart/CompletePurchaseDialog.vue';
import Card from 'vue-stripe-elements-plus/src/Card.vue';
import {
    BOOKING_STATUS,
    CALENDAR_FORMAT,
    getStoreSettings, GIFT_UP_API_URL, GIFT_UP_KEY,
    HELP_EMAIL,
    nil,
    ORDER_STATUS,
    stripeKeys,
    testStripeKeys,
} from '@/common';
import {DateTime} from 'luxon';
import ServiceLineItem from '@/components/Views/Cart/ServiceLineItem.vue';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import PriceTable from '@/components/Views/Cart/PriceTable.vue';
import ScreenSizeMixin from '@/mixins/ScreenSizeMixin.vue';
import axios from 'axios';
import {serviceAsDataLayerProduct} from "@/utils";

@Component({
    components: {
        PriceTable,
        ServiceLineItem,
        Card,
        CompletePurchaseDialog,
    },
})
export default class Cart extends Mixins(CurrencyMixin, UserRoleMixin, GlobalAlertMixin, ScreenSizeMixin) {
    /*get total(): string {
        const guests = this.guests;
        const durations = this.durations;
        return this.priceDisplay(this.items.map((x, index) => {
            return x.service.price * (guests[index] + durations[index] - 1);
        }).reduce((acc, val) => acc + val));
    }*/
    public get subtotal() {
        return this.serviceCost + this.protip;
    }
    get serviceCost() {
        let price = 0;
        for (let i = 0; i < this.items.length; i++) {
            price += this.calculateServicePrice(this.items[i].service.price, this.durations[i], this.guests[i]);
        }
        return price;
    }
    get propay() {
        let pay = 0;
        for (let i = 0; i < this.items.length; i++) {
            if (nil(this.items[i].service.tierModel)) { continue; }
            pay += this.calculateServicePrice(this.items[i].service.price, this.durations[i], this.guests[i]) * this.items[i].service.tierModel.vendorCut;
        }
        return pay;
    }
    get proAmount(){
        let pros = 0;
        for (let i = 0; i < this.items.length; i++) {
            pros += this.splitGuestsByLimitHours(this.items[i].service.hourlyLimit,this.guests[i],this.durations[i]).length;
        }
        return pros;
    }
    get protip() {
        let tip = 0;
        for (let i = 0; i < this.items.length; i++) {
            // const guestCount = this.guests[i];
            // const duration = this.durations[i];
            // const split = guestCount / duration;
            tip += this.calculateServicePrice(this.items[i].service.price, this.durations[i], this.guests[i]) * .2;
            // tip += Math.ceil(split/this.items[i].service.hourlyLimit) * tipForBooking;
        }
        return tip;
    }
    get totalBeforeGiftCard() {
        return  this.subtotal - this.discountAmount;
    }
    get total() {
        return this.totalBeforeGiftCard - this.giftCardAmount;
    }

    public complete = false;

    @Prop({default: () => []})
    public items!: any[];
    public purchaser = null;
    public giftCode = '';
    public giftCardAmount = 0;
    public thanksDialog = false;
    @Sync('booking/formattedAddress') public formattedAddress!: string;
    @Sync('booking/latitude') public latitude!: number;
    @Sync('booking/longitude') public longitude!: number;
    @Sync('booking/durations') public durations!: number[];
    @Sync('booking/guests') public guests!: number[];
    @Sync('booking/services') public services!: any[];
    @Call('booking/setGuests') public setGuests!: (guests: number[]) => number[];
    @Sync('booking/guestToken') public guestToken!: string;
    @Call('booking/setDurations') public setDurations!: (durations: number[]) => number[];
    @Sync('booking/discount') public discount!: number;
    @Sync('booking/discountIsFlat') public discountIsFlat!: boolean;
    @Sync('booking/discountDescription') public discountDescription!: string;
    @Sync('booking/discountForOrder') public discountForOrder!: boolean;

    public headers = [
        {
            name: 'Service',
            value: 'image',
            type: 'image',
            image: (lineItem: any) => `../img/services/${lineItem.service._id}.jpg`,
        },
        {
            name: '',
            value: 'name',
            type: 'string',
            transform: (lineItem: any) => `${lineItem.service.tierModel.name} ${lineItem.service.name}`,
        },
        {
            name: 'Date', value: 'date', type: 'string', transform: (lineItem: any) => {
                // return DateTime.fromFormat(lineItem.date,CALENDAR_FORMAT).toFormat("DDDD")
                return `${DateTime.fromFormat(lineItem.date, CALENDAR_FORMAT).toFormat('DDDD')} at ${DateTime.fromFormat(lineItem.hour, 'HH:mm').toFormat('hh:mm a')}`;
            },
        },
        {name: 'Duration', type: 'adjustable number', model: 'durations', adjustableMax: 12},
        {name: 'Guests', type: 'adjustable number', model: 'guests', adjustableMax: 50},
        {
            name: 'Price', value: 'price', type: 'string', transform: (lineItem: any, quantity: number) => {
                return this.priceDisplay(lineItem.service.price * quantity);
            },
        },
    ];
    private stripeKey = stripeKeys.public;
    public loading = false;
    private settings: any = null;
    private showManualApprovalRequired = false;
    private giftCardOk = false;

    @Watch('purchaser')
    public onPurchaserChanged(value: any, oldValue: any) {
        if (!nil(value)) {
            this.checkout(value);
            this.purchaser = null;
        }
    }

    @Watch('guests')
    public onGuestsChanged(value: number[], oldValue: number[]) {
        this.setGuests(value);
    }

    @Watch('durations')
    public onDurationsChanged(value: number[], oldValue: number[]) {
        this.setDurations(value);
    }

    @Watch('thanksDialog')
    public onThanksDialogChanged(value: boolean, oldValue: boolean) {
        if (!value && oldValue) {
            this.$router.replace('/');
        }
    }
    public clampGiftCardAmount() {
        if (this.giftCardAmount > this.totalBeforeGiftCard) {
            this.giftCardAmount = this.totalBeforeGiftCard;
        }
    }
    public async checkGiftCardValidity() {
        this.loading = true;
        this.giftCardOk = false;
        const settings = await getStoreSettings(this.$FeathersVuex.Setting);
        if (nil(this.giftCode) || nil(this.giftCardAmount, true)) {
            this.getPurchaserInfo();
        } else {
            const url = `${GIFT_UP_API_URL}/gift-cards/${this.giftCode}`;
            axios.defaults.headers.common.Authorization = `Bearer ${GIFT_UP_KEY}`;
            const headers = {'Authorization': `Bearer ${GIFT_UP_KEY}`, 'Accept': 'application/json', 'x-giftup-testmode': settings.testMode};
            try {
                const config = {
                    method: 'GET',
                    headers,
                };
                const response = await axios.get(url, config);
                if (response.status === 200) {
                    const {data} = response;
                    if (data.canBeRedeemed) {
                        if (data.remainingValue >= this.giftCardAmount) {
                            this.giftCardOk = true;
                            this.getPurchaserInfo();
                        } else {
                            this.showAlert(`We're sorry, this gift card contains $${data.remainingValue.toFixed(2)}, which doesn't cover your request of $${this.giftCardAmount.toFixed(2)}`);
                            this.loading = false;
                        }
                    } else {
                        this.showAlert('We\'re sorry, this gift card cannot be redeemed');
                        this.loading = false;
                    }
                } else {
                    this.showAlert('We\'re sorry, We could not find this gift card');
                    this.loading = false;
                }
            } catch (e) {
                this.showAlert(`We're sorry, There was a server error while validating your gift card`);
                console.log(e);
                this.loading = false;
            }
        }
    }

    public async getPurchaserInfo() {
        if (!this.userIsNull) {
            const {Purchaser} = this.$FeathersVuex;
            const purchasers = await Purchaser.find({
                query: {
                    user: this.user._id,
                },
            });
            if (purchasers.total === 1) {
                this.checkout(purchasers.data[0]);
            } else {
                this.showManualApprovalRequired = await this.manualApprovalRequired();
                (this.$refs.completePurchaseDialog as any).open = true;
            }
        } else {
            this.showManualApprovalRequired = await this.manualApprovalRequired();
            (this.$refs.completePurchaseDialog as any).open = true;
        }
    }

    public async checkout(purchaser) {
        const {Order, Booking} = this.$FeathersVuex;
        const {services, dates, times, vendors, durations, guests} = this.$store.state.booking;
        if (services.length !== dates.length || dates.length !== times.length || vendors.length !== services.length) {
            const lengths = {
                services: services.length,
                dates: dates.length,
                times: times.length,
                vendors: vendors.length,
            };
            throw Error(`inconsistent selection, cannot book ${JSON.stringify(lengths)}`);
        }
        const createdBookings: any[] = [];
        for (let i = 0; i < services.length; i++) {
            const givenDateTime =`${dates[i]} ${times[i]}`;
            const date = DateTime.fromFormat(givenDateTime, 'yyyy-MM-dd HH:mm').toISO();
            const split = this.splitGuestsByLimitHours(this.items[i].service.hourlyLimit,this.guests[i],this.durations[i]);
            const groupPayment = this.calculateServicePrice(this.items[i].service.price, this.durations[i], this.guests[i]);
            const groupTip = groupPayment * 0.2;
            for(let p = 0; p < split.length; p++) {
                const hasRequestedVendor = !nil(vendors[i]) && p === 0;
                const booking = new Booking({
                    service: services[i]._id,
                    requestedVendor: hasRequestedVendor ? vendors[i]._id : undefined,
                    status: hasRequestedVendor ? BOOKING_STATUS.WAITING_ON_REQUESTED_PRO : BOOKING_STATUS.WAITING_ON_ANY_PRO,
                    address: this.formattedAddress,
                    location: {
                        coordinates: [this.longitude, this.latitude],
                    },
                    date,
                    givenDateTime,
                    groupKey:`${i}-${services[i]._id.toString()}`,
                    groupPayment,
                    groupTip,
                    groupProCount:split.length,
                    duration: durations[i],
                    guests:split[p],
                    purchaser: purchaser._id,
                });
                try {
                    const createdBooking = await booking.create();
                    createdBookings.push(createdBooking);
                } catch (e) {
                    for (const alreadyCreated of createdBookings) {
                        alreadyCreated.remove();
                    }
                    this.$bus.$emit('showAlert', {
                        type: 'error',
                        isHTML: true,
                        text: `There was a problem placing your booking, please contact ${HELP_EMAIL} if this persists.<br/>${e.message}`,
                        timeout: 7000,
                    });
                    this.loading = false;
                    return;
                }
            }
        }
        try {
            const discount = this.discountAmount === 0 ? {} : this.discountIsFlat ? { discount: this.discountAmount } : {
                bundleDiscountWithProperties: {
                    title: 'Bridal Party Bundle',
                    description: `10% Discount for 10 or more guests in this ${this.services[0].tierModel.name} bundle. Appointments booked include: ${createdBookings.map((x) => x.name).join(',')}`,
                    protip: this.protip,
                    price: this.total - this.protip,
                },
            };
            const giftCardData = !this.giftCardOk ? {} : {
                giftCardUsed: this.giftCode,
                giftCardPaymentSubmitted: this.giftCardAmount,
            };
            const order = new Order({
                bookings: createdBookings.map((x) => x._id),
                purchaser: purchaser._id,
                status: ORDER_STATUS.PLACING,
                servicesTotal: this.serviceCost,
                proTipTotal: this.protip,
                proPaymentTotal: this.propay,
                discountTotal: this.discountAmount,
                ...discount,
                ...giftCardData,
            });
            const orderMade = await order.create();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'purchaserId',
                userId: purchaser.email,
            });
            window.dataLayer.push({
                event: 'checkout',
                ecommerce: {
                    actionField:{'step':5},
                    products:this.services.map(serviceAsDataLayerProduct)
                }
            });
            setTimeout(()=>{
                this.proceedToStripe(orderMade)
            },150);

        } catch (e) {
            this.showAlert(`There was a problem placing your order, please contact ${HELP_EMAIL} if this persists.`, 'error');
            console.log(`error : ${e.message}`);
        }

    }

    public async proceedToStripe(orderModel) {
        //console.log('here we go...');
        if (nil(orderModel.stripeSessionId) && orderModel.status === ORDER_STATUS.PAID) {
            this.$router.replace(`/order/${orderModel._id}`);
        } else if (nil(orderModel.stripeSessionId)) {
            //console.log('oh no error');
            this.showAlert(`There was a problem placing your order, please contact ${HELP_EMAIL} if this persists.`);
        } else {
            //console.log('checking if manual approval is needed');
            //
            const needsManualApproval = await this.manualApprovalRequired();
            if (needsManualApproval) {
                orderModel.status = ORDER_STATUS.REQUIRES_REVIEW;
                orderModel.save();
                this.$router.push(`/pending/${orderModel._id}`);
            } else {
                const settings = await getStoreSettings(this.$FeathersVuex.Setting);
                const stripe = (window as any).Stripe(settings.testMode ? testStripeKeys.public : stripeKeys.public);
                const checkout = await stripe.redirectToCheckout({sessionId: orderModel.stripeSessionId});
            }
        }
    }

    public splitGuestsByLimitHours(limit:number, guests:number, hours:number, group: number[] = []) {
        let limitHours = limit * hours;
        if (limitHours > guests) {
            limitHours = guests;
        }
        guests -= limitHours;
        group.push(limitHours);
        if (guests > 0) {
            return this.splitGuestsByLimitHours(limit, guests, hours, group);
        } else {
            let smallest = Number.POSITIVE_INFINITY,
                biggest = Number.NEGATIVE_INFINITY;
            do {
                group = group.sort((a, b) => b - a);
                let biggest = group[0];
                let smallest = group[group.length - 1];
                if (smallest < biggest) {
                    const transfer = Math.floor(biggest / 2);
                    group[0] -= transfer;
                    group[group.length - 1] += transfer;
                }
            } while (smallest < biggest);
            return group.sort((a, b) => b - a);
        }
    }

    public async manualApprovalRequired() {
        if (nil(this.settings)) {
            this.settings = await getStoreSettings(this.$FeathersVuex.Setting);
        }
        return this.total >= this.settings.priceThreshold;
    }

    public mounted() {
        this.ensureFilledQuantities();
    }

    public created() {
        this.ensureFilledQuantities();
    }

    public ensureFilledQuantities() {
        if (this.durations.length !== this.services.length) {
            const durations = this.services.map((x) => 1);
            this.setDurations(durations);
        }
        if (this.guests.length !== this.services.length) {
            const guests = this.services.map((x) => 1);
            this.setGuests(guests);
        }
    }
    get packageMode() {
        return this.$route.path.indexOf('package') > -1;
    }
    public get discountAmount() {
        if (this.discount === 0) { return 0; }
        return this.discountIsFlat ? this.discount : this.subtotal * this.discount;
    }
}
